import { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { DocumentTemplatesPanel } from "@/components/DocumentTemplatesPanel";
import { aktiverBeleg, vorlageAnBeleg, useVorlagenFenster } from "@/lib/windowSync";

// Eigenes Vorlagen-Fenster (zweiter Bildschirm, frei verschieb-/vergrößerbar): dieselbe Liste wie in den Einstellungen im Auswahl-Modus
// (Ansehen, Übernehmen). „Übernehmen“ geht an den zuletzt aktiven offenen Beleg; Anhängen/Ersetzen fragt der Beleg selbst.
const HINWEIS = "Bitte zuerst ein Angebot, eine Auftragsbestätigung oder eine Rechnung öffnen.";

const VorlagenFensterPage = () => {
  const [ziel, setZiel] = useState(null);   // { label, art } des zuletzt aktiven offenen Belegs
  useVorlagenFenster();
  const wurzel = useRef(null);
  const [hoehe, setHoehe] = useState(null);
  useEffect(() => {
    const f = () => { if (wurzel.current) setHoehe(Math.max(200, window.innerHeight - wurzel.current.getBoundingClientRect().top - window.scrollY)); };
    f();
    window.addEventListener("resize", f);
    const t = setInterval(f, 1500);
    return () => { window.removeEventListener("resize", f); clearInterval(t); };
  }, []);
  useEffect(() => {
    let aus = false;
    const frage = async () => { const z = await aktiverBeleg(); if (!aus) setZiel(z); };
    frage();
    const t = setInterval(frage, 2000);
    return () => { aus = true; clearInterval(t); };
  }, []);

  const uebernehmen = async (tpl) => {
    const ok = await vorlageAnBeleg(tpl);
    if (ok) toast.success(`Vorlage „${tpl.name}“ geschickt an ${ziel?.label || "den Beleg"} – dort wird übernommen (bei vorhandenen Positionen fragt der Beleg: Anhängen oder Ersetzen)`, { duration: 8000 });
    else toast.warning(`Kein Beleg offen – ${HINWEIS}`, { duration: 8000 });
  };

  return (
    <div ref={wurzel} style={hoehe ? { height: hoehe } : undefined} className="h-screen w-full max-w-full overflow-hidden flex flex-col bg-background" data-testid="vorlagen-fenster">
      <header className="shrink-0 bg-primary text-primary-foreground px-4 py-2.5 flex flex-wrap items-baseline gap-x-3">
        <h1 className="font-semibold">Vorlagen</h1>
        <span className="text-sm opacity-90" data-testid="fenster-ziel">
          {ziel ? <>fügt ein in: {ziel.label}</> : `kein Beleg offen – ${HINWEIS}`}
        </span>
      </header>
      <div className="flex-1 min-h-0 overflow-y-auto p-3 sm:p-4">
        <DocumentTemplatesPanel
          variant="embedded"
          auswahl={{ docType: ziel?.art, onUebernehmen: uebernehmen, gesperrt: !ziel, gesperrtHinweis: HINWEIS }}
        />
      </div>
    </div>
  );
};

export default VorlagenFensterPage;
